import { render, staticRenderFns } from "./IssueDetail.vue?vue&type=template&id=6cacf0e8"
import script from "./IssueDetail.vue?vue&type=script&lang=js"
export * from "./IssueDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports